import { request } from '../utils';

export default ( baseUrl, cache ) => ( ctx, payload = {}) => {
  return request( ctx, `${baseUrl}/list`, payload, cache );
};
